<template>
  <nav :class="classes" class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <slot></slot>
      <span v-if="loggedIn">
        <background-task-progress></background-task-progress>
        <zipcode-cache-warning></zipcode-cache-warning>
      </span>
      <CollapseTransition>
        <div
          class="collapse navbar-collapse justify-content-end show"
          :class="navbarMenuClasses"
          v-show="showNavbar"
          id="navigation"
        >
          <ul class="navbar-nav">
            <slot name="navbar-menu"></slot>
          </ul>
        </div>
      </CollapseTransition>
    </div>
  </nav>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import BackgroundTaskProgress from "src/components/UIComponents/Navbar/BackgroundTaskProgress";
import ZipcodeCacheWarning from "src/components/UIComponents/Navbar/ZipcodeCacheWarning";

export default {
  name: "navbar",
  props: {
    showNavbar: {
      type: Boolean,
      description: "Whether navbar is visible"
    },
    navbarMenuClasses: {
      type: [String, Object],
      description: "Navbar menu css classes"
    },
    transparent: {
      type: Boolean,
      default: true,
      description: "Whether navbar is transparent"
    },
    position: {
      type: String,
      default: "absolute",
      description: "Navbar position (absolute|fixed|relative)"
    },
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      },
      description: "Navbar type (primary|info|danger|default|warning|success)"
    }
  },
  components: {
    CollapseTransition,
    BackgroundTaskProgress,
    ZipcodeCacheWarning
  },
  computed: {
    classes() {
      let color = `bg-${this.type}`;
      let navPosition = `navbar-${this.position}`;
      return [
        { "navbar-transparent": !this.showNavbar && this.transparent },
        { [color]: this.showNavbar || !this.transparent },
        navPosition
      ];
    },
    loggedIn() {
      return Laravel.user !== null;
    }
  }
};
</script>
<style scoped>
.navbar-relative {
  position: relative;
}
</style>
